import { render, staticRenderFns } from "./GeneralProductStatementsSelector.vue?vue&type=template&id=5fc2d110&"
import script from "./GeneralProductStatementsSelector.vue?vue&type=script&lang=js&"
export * from "./GeneralProductStatementsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports